import { LAYOUTS, } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { continueAction, downloadDocument, goBack, uploadDocumentToS3, viewSampleDocument, viewUploadedDocument } from "./actions";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
import SharedPropsService from "../../SharedPropsService";
export const template = (height, documentDetails, docDownloadDetails) => ({
    layout: {
        id: ROUTE.AS_ES_INDIVIDUAL_DOCUMENT,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "asESIndividualDocumentDC", type: WIDGET.AS_ES_INDIVIDUAL_DOCUMENT }
        ],
    },
    datastore: {
        asESIndividualDocumentDC: {
            height: height,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.AS_ES_INDIVIDUAL_DOCUMENT,
                payload: {}
            },
            documentDetails: documentDetails,
            viewSampleDocumentAction: {
                type: ACTION.VIEW_SAMPLE_DOCUMENT,
                routeId: ROUTE.AS_ES_INDIVIDUAL_DOCUMENT,
                payload: {}
            },
            downloadFormAction: {
                type: ACTION.DOCUMENT_DOWNLOAD,
                routeId: ROUTE.AS_ES_INDIVIDUAL_DOCUMENT,
                payload: {}
            },
            downloadDocumentLoading: false,
            docDownloadDetails: docDownloadDetails,
            uploadFormAction: {
                type: ACTION.UPLOAD_DOCUMENT,
                routeId: ROUTE.AS_ES_INDIVIDUAL_DOCUMENT,
                payload: {}
            },
            viewUploadedFile: {
                type: ACTION.VIEW_UPLOADED_DOCUMENT,
                routeId: ROUTE.AS_ES_INDIVIDUAL_DOCUMENT,
                payload: {}
            },
            continueAction: {
                type: ACTION.CONTINUE,
                routeId: ROUTE.AS_ES_INDIVIDUAL_DOCUMENT,
                payload: {}
            },
            documentUploadFailed: false
        }
    },
});
export const asESIndividualDocumentMF = {
    onLoad: async ({ getHeight, network, removeWidgets }, { documentDetails }) => {
        let applicationId;
        if (await AsyncStorage.getItem("application_id")) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            const user = await SharedPropsService.getUser();
            applicationId = user.linkedApplications[0].applicationId;
        }
        const individualDocInit = await network.post(`${api.individualDocInit}${applicationId}`, {
            documentId: documentDetails?.documentId
        }, {
            headers: await getAppHeader(),
        });
        const docDownloadDetails = individualDocInit?.data?.stepResponseObject;
        return Promise.resolve(template(getHeight(), documentDetails, docDownloadDetails));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.VIEW_SAMPLE_DOCUMENT]: viewSampleDocument,
        [ACTION.DOCUMENT_DOWNLOAD]: downloadDocument,
        [ACTION.CONTINUE]: continueAction,
        [ACTION.UPLOAD_DOCUMENT]: uploadDocumentToS3,
        [ACTION.VIEW_UPLOADED_DOCUMENT]: viewUploadedDocument,
    },
    clearPrevious: true,
};
